import { Delete } from "assets/icons/Common";
import { Modal, ModalFooterAction } from "components/primitives/Modal";
import { ModalsContext } from "contexts/ModalsContext";
import { useContext } from "react";

import { MODAL_DELETE_DASHBOARD } from "./constants";
import { ModalHeaderStyled, ModalMessageBox } from "./multipleDashboards.styles";

interface ModalDeleteDashboardProps {
  onDelete: () => void;
}

export const ModalDeleteDashboard = (props: ModalDeleteDashboardProps) => {
  const modalsContext = useContext(ModalsContext);

  const handleDelete = () => {
    props.onDelete();
    modalsContext.closeModal();
  };

  const handleClose = () => {
    modalsContext.closeModal();
  };

  const footerActions: ModalFooterAction[] = [
    {
      key: "cancel",
      textBtn: "Cancel",
      color: "var(--primary)",
      action: handleClose,
    },
    {
      key: "delete",
      textBtn: "Delete",
      color: "var(--danger)",
      action: handleDelete,
    },
  ];

  return (
    <Modal
      isOpen={modalsContext.modalData.name === MODAL_DELETE_DASHBOARD}
      footerActions={footerActions}
      header={
        <ModalHeaderStyled>
          <Delete />
          Delete Slide
        </ModalHeaderStyled>
      }
    >
      <ModalMessageBox>
        <p>Are you sure you want to delete this slide?</p>
        <p>This action is permanent.</p>
      </ModalMessageBox>
    </Modal>
  );
};
